(function () {
  'use strict';
  if (window.AcquaNavigationController) return;
  window.AcquaNavigationController = true;

  var root = null;
  var nav = null;
  var sources = null;
  var modal = null;
  var backdrop = null;
  var index = null;
  var detail = null;
  var title = null;
  var mobileToggle = null;
  var departments = [];
  var active = null;
  var lastDepartment = null;
  var editorView = null;
  var returnFocus = null;
  var isOpen = false;
  var mobileAtOpen = false;
  var bodyOverflow = null;
  var inertElements = [];
  var resizeObserver = null;
  var positionFrame = 0;
  var leaveTimer = 0;
  var mobileQuery = window.matchMedia('(max-width: 1150px)');

  function label(key, fallback) {
    return (root && root.dataset[key]) || fallback;
  }

  function isMobile() {
    return mobileQuery.matches;
  }

  function editorBlock(element) {
    var value = element && element.getAttribute('data-shopify-editor-block');
    if (!value) return null;
    try {
      return JSON.parse(value);
    } catch (error) {
      return null;
    }
  }

  function axisKey(panel) {
    var block = editorBlock(panel);
    return (block && block.id) || panel.id;
  }

  function rememberEditorView() {
    if (!window.Shopify || !window.Shopify.designMode || !isOpen || !active) return;
    var selectedAxis = active.axes.find(function (axis) { return !axis.panel.hidden; });
    editorView = {
      sectionId: active.source.dataset.sectionId,
      axisId: selectedAxis ? axisKey(selectedAxis.panel) : null,
      stickyMenu: root.classList.contains('is-sticky-menu')
    };
  }

  function restoreEditorView() {
    if (!editorView) return;
    var department = departments.find(function (item) {
      return item && item.source.dataset.sectionId === editorView.sectionId;
    });
    if (!department) return;
    var axis = department.axes.find(function (item) { return axisKey(item.panel) === editorView.axisId; });
    if (editorView.stickyMenu && !isMobile()) root.classList.add('is-sticky-menu');
    editorView = null;
    open(department, false);
    if (axis) setAxis(department, axis, false);
  }

  function makeButton(className, text, titleText) {
    var button = document.createElement('button');
    button.type = 'button';
    button.className = className;
    button.textContent = text;
    if (titleText) button.setAttribute('aria-label', titleText);
    return button;
  }

  function makeLink(className, text, href) {
    var link = document.createElement(href ? 'a' : 'span');
    link.className = className;
    link.textContent = text;
    if (href) link.href = href;
    return link;
  }

  function positionPanel() {
    positionFrame = 0;
    if (!root || !nav || !isOpen || isMobile()) return;
    if (root.classList.contains('is-sticky-menu')) {
      var headerMain = document.querySelector('[data-site-header-main]');
      var headerBottom = headerMain ? headerMain.getBoundingClientRect().bottom : 0;
      root.style.setProperty('--nav-bar-top', Math.max(0, headerBottom) + 'px');
    }
    var top = Math.max(0, nav.getBoundingClientRect().bottom + 10);
    root.style.setProperty('--nav-panel-top', top + 'px');
    root.style.setProperty('--menu-room', Math.max(0, window.innerHeight - top - 16) + 'px');
  }

  function schedulePosition() {
    if (!positionFrame) positionFrame = window.requestAnimationFrame(positionPanel);
  }

  function lockBackground() {
    bodyOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    inertElements = Array.prototype.slice.call(document.querySelectorAll('main, footer'))
      .filter(function (element) { return !element.contains(root); })
      .map(function (element) {
        var wasInert = element.hasAttribute('inert');
        element.setAttribute('inert', '');
        return { element: element, wasInert: wasInert };
      });
  }

  function unlockBackground() {
    inertElements.forEach(function (record) {
      if (!record.wasInert) record.element.removeAttribute('inert');
    });
    inertElements = [];
    if (bodyOverflow !== null && document.body.style.overflow === 'hidden') {
      document.body.style.overflow = bodyOverflow;
    }
    bodyOverflow = null;
  }

  function restorePanel() {
    if (!active) return;
    if (active.placeholder.parentNode) {
      if (active.mount.isConnected) {
        active.placeholder.parentNode.replaceChild(active.mount, active.placeholder);
      } else {
        active.placeholder.remove();
      }
    }
    if (active.mount !== active.panel) active.source.open = false;
    active.trigger.setAttribute('aria-expanded', 'false');
    active.entry.setAttribute('aria-expanded', 'false');
    active.trigger.classList.remove('is-active');
    active.entry.classList.remove('is-active');
    active = null;
  }

  function setAxis(department, selected, moveFocus) {
    var axes = department.axes;
    if (!axes.length) return;
    var chosen = axes.indexOf(selected) >= 0 ? selected : axes[0];
    axes.forEach(function (axis) {
      var selectedNow = axis === chosen;
      axis.panel.hidden = !selectedNow;
      axis.tab.classList.toggle('is-active', selectedNow);
      axis.tab.setAttribute('aria-selected', String(selectedNow));
      axis.tab.tabIndex = selectedNow ? 0 : -1;
    });
    if (moveFocus) chosen.tab.focus();
  }

  function updateFeatured(department) {
    department.featured.forEach(function (carousel) {
      var cards = carousel.cards;
      var first = carousel.page * 2;
      cards.forEach(function (card, position) {
        card.hidden = position < first || position >= first + 2;
      });
      if (carousel.previous) carousel.previous.disabled = carousel.page === 0;
      if (carousel.next) carousel.next.disabled = first + 2 >= cards.length;
      if (carousel.count) {
        var format = label('labelFeaturedCount', '{first}–{last} of {total}');
        carousel.count.textContent = format
          .replace(/\{\{\s*first\s*\}\}|\{first\}/g, String(first + 1))
          .replace(/\{\{\s*last\s*\}\}|\{last\}/g, String(Math.min(first + 2, cards.length)))
          .replace(/\{\{\s*total\s*\}\}|\{total\}/g, String(cards.length));
      }
    });
  }

  function buildAxes(department, number) {
    department.axes = Array.prototype.slice.call(department.panel.querySelectorAll('[data-nav-axis]'))
      .map(function (panel, axisNumber) {
        var shopArea = panel.closest('.shop-area');
        var tablist = shopArea && shopArea.querySelector('.axis-tabs');
        if (!tablist) return null;
        if (!panel.id) panel.id = 'acqua-nav-axis-' + number + '-' + axisNumber;
        var tab = makeButton('axis-tab', panel.dataset.title || '', null);
        tab.id = 'acqua-nav-tab-' + number + '-' + axisNumber;
        tab.setAttribute('role', 'tab');
        tab.setAttribute('aria-controls', panel.id);
        tablist.appendChild(tab);
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('aria-labelledby', tab.id);
        return { panel: panel, tab: tab };
      }).filter(Boolean);
    setAxis(department, department.axes[0], false);
  }

  function buildFeatured(department) {
    department.featured = Array.prototype.slice.call(department.panel.querySelectorAll('.featured-products'))
      .map(function (container) {
        var cards = Array.prototype.slice.call(container.querySelectorAll('[data-nav-featured-card]'));
        if (!cards.length) return null;
        var controls = container.parentElement.querySelector('.featured-controls');
        if (!controls) {
          controls = document.createElement('div');
          controls.className = 'featured-controls';
          controls.dataset.navGenerated = '';
          container.insertAdjacentElement('afterend', controls);
        }
        var previous = controls.querySelector('[data-featured-step="-1"]');
        var next = controls.querySelector('[data-featured-step="1"]');
        var count = container.parentElement.querySelector('.featured-count');
        if (!previous) {
          previous = makeButton('featured-prev', '‹', label('labelPrevious', 'Previous'));
          previous.dataset.featuredStep = '-1';
          controls.appendChild(previous);
        }
        if (!count) {
          count = document.createElement('span');
          count.className = 'featured-count';
          controls.appendChild(count);
        }
        if (!next) {
          next = makeButton('featured-next', '›', label('labelNext', 'Next'));
          next.dataset.featuredStep = '1';
          controls.appendChild(next);
        }
        previous.setAttribute('aria-label', label('labelPrevious', 'Previous'));
        next.setAttribute('aria-label', label('labelNext', 'Next'));
        count.setAttribute('aria-live', 'polite');
        return { cards: cards, previous: previous, next: next, count: count, page: 0 };
      }).filter(Boolean);
    updateFeatured(department);
  }

  function setMobileView(showDetail) {
    index.hidden = !isMobile() || showDetail;
    detail.hidden = isMobile() && !showDetail;
    modal.classList.toggle('is-mobile-index', isMobile() && !showDetail);
    modal.classList.toggle('is-mobile-detail', isMobile() && showDetail);
    var back = modal.querySelector('.back-departments');
    if (back) back.hidden = !isMobile() || !showDetail;
  }

  function showDepartment(department, focusPanel) {
    if (!department || !department.mount.isConnected) return;
    editorView = null;
    if (active === department) {
      if (focusPanel && isMobile()) {
        var activeBack = modal.querySelector('.back-departments');
        (activeBack || modal).focus();
      }
      return;
    }
    restorePanel();
    active = department;
    lastDepartment = department;
    department.mount.parentNode.insertBefore(department.placeholder, department.mount);
    if (department.mount !== department.panel) department.source.open = true;
    detail.appendChild(department.mount);
    department.trigger.setAttribute('aria-expanded', 'true');
    department.entry.setAttribute('aria-expanded', 'true');
    department.trigger.classList.add('is-active');
    department.entry.classList.add('is-active');
    title.textContent = department.name;
    modal.setAttribute('aria-label', department.name);
    setMobileView(true);
    setAxis(department, department.axes[0], false);
    updateFeatured(department);
    schedulePosition();
    if (focusPanel && isMobile()) {
      var back = modal.querySelector('.back-departments');
      (back || modal).focus();
    }
  }

  function open(department, focusPanel) {
    if (!root) return;
    if (!isOpen) {
      isOpen = true;
      mobileAtOpen = isMobile();
      returnFocus = document.activeElement.closest('button, a, [tabindex="0"]') || document.activeElement;
      root.classList.add('is-open');
      modal.hidden = false;
      backdrop.hidden = false;
      modal.setAttribute('aria-modal', String(mobileAtOpen));
      if (mobileAtOpen) lockBackground();
    }
    if (department) {
      showDepartment(department, focusPanel);
    } else {
      restorePanel();
      title.textContent = label('labelDepartments', 'Shop departments');
      modal.setAttribute('aria-label', label('labelNav', 'Product departments'));
      setMobileView(false);
      if (isMobile()) {
        var first = index.querySelector('button');
        (first || modal).focus();
      }
    }
    if (mobileToggle) {
      mobileToggle.setAttribute('aria-expanded', String(isMobile() || root.classList.contains('is-sticky-menu')));
    }
    schedulePosition();
  }

  function close(restoreFocus) {
    if (!isOpen) return;
    window.clearTimeout(leaveTimer);
    isOpen = false;
    restorePanel();
    root.classList.remove('is-open', 'is-sticky-menu');
    modal.hidden = true;
    backdrop.hidden = true;
    modal.classList.remove('is-mobile-index', 'is-mobile-detail');
    if (mobileToggle) mobileToggle.setAttribute('aria-expanded', 'false');
    if (mobileAtOpen) unlockBackground();
    root.style.removeProperty('--nav-panel-top');
    root.style.removeProperty('--nav-bar-top');
    root.style.removeProperty('--menu-room');
    if (restoreFocus && returnFocus && document.contains(returnFocus)) returnFocus.focus();
    returnFocus = null;
  }

  function getDepartment(element) {
    var item = element && element.closest('[data-nav-number]');
    return item ? departments[Number(item.dataset.navNumber)] : null;
  }

  function onRootClick(event) {
    var trigger = event.target.closest('.department-trigger');
    if (trigger && nav.contains(trigger)) {
      event.preventDefault();
      var chosen = getDepartment(trigger);
      if (!isOpen || active !== chosen) open(chosen, false);
      if (event.detail === 0 && chosen) {
        var heading = chosen.panel.querySelector('.menu-heading h2');
        if (heading) heading.focus();
      }
      return;
    }
    var entry = event.target.closest('.department-entry');
    if (entry && index.contains(entry)) {
      event.preventDefault();
      showDepartment(getDepartment(entry), true);
      return;
    }
    if (event.target.closest('.back-departments')) {
      event.preventDefault();
      var previousEntry = active && active.entry;
      open(null, true);
      if (previousEntry) previousEntry.focus();
      return;
    }
    if (event.target.closest('.close-menu, .desktop-close') || event.target === backdrop) {
      event.preventDefault();
      close(true);
      return;
    }
    var tab = event.target.closest('.axis-tab');
    if (tab && active) {
      var axis = active.axes.find(function (item) { return item.tab === tab; });
      if (axis) setAxis(active, axis, false);
      return;
    }
    var step = event.target.closest('[data-featured-step]');
    if (step && active) {
      event.preventDefault();
      var carousel = active.featured.find(function (item) {
        return item.previous === step || item.next === step;
      });
      if (!carousel) return;
      carousel.page = Math.max(0, Math.min(Math.ceil(carousel.cards.length / 2) - 1,
        carousel.page + Number(step.dataset.featuredStep)));
      updateFeatured(active);
    }
  }

  function onRootKeydown(event) {
    var tab = event.target.closest('.axis-tab');
    if (!tab || !active) return;
    var tabs = active.axes;
    var current = tabs.findIndex(function (item) { return item.tab === tab; });
    if (current < 0) return;
    var next = current;
    if (event.key === 'ArrowRight') next = (current + 1) % tabs.length;
    else if (event.key === 'ArrowLeft') next = (current - 1 + tabs.length) % tabs.length;
    else if (event.key === 'Home') next = 0;
    else if (event.key === 'End') next = tabs.length - 1;
    else return;
    event.preventDefault();
    setAxis(active, tabs[next], true);
  }

  function onPointerOver(event) {
    if (isMobile() || event.pointerType !== 'mouse') return;
    // The full-page backdrop is a root descendant, but is not part of the menu.
    if (!nav.contains(event.target) && !modal.contains(event.target)) {
      onPointerLeave(event);
      return;
    }
    window.clearTimeout(leaveTimer);
    var item = event.target.closest('.department-nav-item');
    if (item && nav.contains(item)) {
      if (!isOpen || active !== getDepartment(item)) open(getDepartment(item), false);
    }
  }

  function onPointerLeave(event) {
    if (event && event.pointerType !== 'mouse') return;
    if (window.Shopify && window.Shopify.designMode) return;
    if (isOpen && !isMobile()) {
      window.clearTimeout(leaveTimer);
      leaveTimer = window.setTimeout(function () {
        // Moving the mouse must not dismiss a menu being operated by keyboard.
        if (root.contains(document.activeElement) && document.activeElement.matches(':focus-visible')) return;
        close(false);
      }, 300);
    }
  }

  function focusables() {
    return Array.prototype.slice.call(modal.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])'))
      .filter(function (element) {
        return !element.closest('[hidden]') && element.getClientRects().length > 0;
      });
  }

  function onDocumentKeydown(event) {
    if (!isOpen) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      close(true);
      return;
    }
    if (event.key !== 'Tab' || !isMobile()) return;
    var items = focusables();
    if (!items.length) {
      event.preventDefault();
      modal.focus();
      return;
    }
    var first = items[0];
    var last = items[items.length - 1];
    if (event.shiftKey && (document.activeElement === first || document.activeElement === modal)) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && (document.activeElement === last || !modal.contains(document.activeElement))) {
      event.preventDefault();
      first.focus();
    }
  }

  function onDocumentClick(event) {
    var toggle = event.target.closest('[data-acqua-menu-toggle]');
    if (toggle && toggle === mobileToggle) {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (isOpen) close(true);
      else if (isMobile()) open(null, true);
      else {
        root.classList.add('is-sticky-menu');
        var department = lastDepartment || departments.find(Boolean);
        open(department, false);
        if (event.detail === 0 && department) {
          var heading = department.panel.querySelector('.menu-heading h2');
          if (heading) heading.focus();
        }
      }
      return;
    }
    if (isOpen && !root.contains(event.target)) close(false);
  }

  function onDocumentFocusIn(event) {
    if (!isOpen || isMobile() || (window.Shopify && window.Shopify.designMode)) return;
    if (!root.contains(event.target)) close(false);
  }

  function onResize() {
    if (isOpen && mobileAtOpen !== isMobile()) {
      var focusTarget = isMobile() ? mobileToggle : ((active || departments[0]) || {}).trigger;
      close(false);
      if (focusTarget) focusTarget.focus();
    } else schedulePosition();
  }

  function build() {
    var sourceNodes = Array.prototype.slice.call(sources.querySelectorAll('[data-nav-source]'));
    if (!sourceNodes.length || sourceNodes.some(function (source) {
      return !source.querySelector('[data-nav-department]');
    })) return;
    sourceNodes.forEach(function (source, number) {
      var panel = source.querySelector('[data-nav-department]');
      if (!panel) return;
      source.open = false;
      var name = source.dataset.title || (source.querySelector('summary') || {}).textContent || '';
      name = name.trim();
      var departmentLink = source.dataset.link || '';
      var navItem = document.createElement('div');
      navItem.className = 'department-nav-item';
      navItem.dataset.navNumber = String(number);
      var trigger = makeButton('department-trigger department-toggle', '', 'Open ' + name + ' menu');
      var navLink = makeLink('department-link', name, departmentLink);
      var indexItem = document.createElement('div');
      indexItem.className = 'department-index-item';
      indexItem.dataset.navNumber = String(number);
      var indexLink = makeLink('department-entry-link', name, departmentLink);
      var entry = makeButton('department-entry department-index-button', '', 'Open ' + name + ' menu');
      trigger.dataset.navNumber = String(number);
      entry.dataset.navNumber = String(number);
      trigger.setAttribute('aria-controls', modal.id);
      entry.setAttribute('aria-controls', modal.id);
      trigger.setAttribute('aria-expanded', 'false');
      entry.setAttribute('aria-expanded', 'false');
      navItem.appendChild(navLink);
      navItem.appendChild(trigger);
      nav.appendChild(navItem);
      indexItem.appendChild(indexLink);
      indexItem.appendChild(entry);
      index.appendChild(indexItem);
      var department = {
        source: source, panel: panel, placeholder: document.createComment('acqua navigation panel'),
        mount: root.classList.contains('is-design-mode') ?
          (source.closest('[id^="shopify-section-"]') || source) : panel,
        name: name, trigger: trigger, entry: entry, axes: [], featured: []
      };
      departments[number] = department;
      buildAxes(department, number);
      buildFeatured(department);
    });
    sources.hidden = true;
    root.classList.add('is-ready', 'is-enhanced');
    if (mobileToggle) {
      mobileToggle.setAttribute('aria-controls', modal.id);
      mobileToggle.setAttribute('aria-expanded', 'false');
    }
    modal.tabIndex = -1;
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-label', label('labelNav', 'Product departments'));
    modal.hidden = true;
    backdrop.hidden = true;
    var back = modal.querySelector('.back-departments');
    var dismiss = modal.querySelector('.close-menu');
    if (back) back.setAttribute('aria-label', label('labelBack', 'Back to departments'));
    if (dismiss) dismiss.setAttribute('aria-label', label('labelClose', 'Close navigation'));
    root.addEventListener('click', onRootClick);
    root.addEventListener('keydown', onRootKeydown);
    root.addEventListener('pointerover', onPointerOver);
    root.addEventListener('pointerleave', onPointerLeave);
    document.addEventListener('click', onDocumentClick, true);
    document.addEventListener('keydown', onDocumentKeydown, true);
    document.addEventListener('focusin', onDocumentFocusIn, true);
    window.addEventListener('resize', onResize);
    window.addEventListener('scroll', schedulePosition, true);
    if (window.ResizeObserver) {
      resizeObserver = new ResizeObserver(schedulePosition);
      resizeObserver.observe(nav);
    }
  }

  function destroy() {
    if (!root) return;
    close(false);
    root.removeEventListener('click', onRootClick);
    root.removeEventListener('keydown', onRootKeydown);
    root.removeEventListener('pointerover', onPointerOver);
    root.removeEventListener('pointerleave', onPointerLeave);
    document.removeEventListener('click', onDocumentClick, true);
    document.removeEventListener('keydown', onDocumentKeydown, true);
    document.removeEventListener('focusin', onDocumentFocusIn, true);
    window.removeEventListener('resize', onResize);
    window.removeEventListener('scroll', schedulePosition, true);
    if (resizeObserver) resizeObserver.disconnect();
    resizeObserver = null;
    if (positionFrame) window.cancelAnimationFrame(positionFrame);
    positionFrame = 0;
    window.clearTimeout(leaveTimer);
    departments.forEach(function (department) {
      if (!department) return;
      department.axes.forEach(function (axis) {
        axis.panel.hidden = false;
        axis.panel.removeAttribute('aria-labelledby');
        axis.tab.remove();
      });
      department.featured.forEach(function (carousel) {
        carousel.cards.forEach(function (card) { card.hidden = false; });
        var controls = carousel.count.closest('.featured-controls');
        if (controls && controls.hasAttribute('data-nav-generated')) controls.remove();
      });
    });
    nav.replaceChildren();
    index.replaceChildren();
    sources.hidden = false;
    root.classList.remove('is-ready', 'is-enhanced', 'is-design-mode');
    root = nav = sources = modal = backdrop = index = detail = title = mobileToggle = null;
    departments = [];
    lastDepartment = null;
  }

  function init() {
    rememberEditorView();
    destroy();
    var candidate = document.querySelector('acqua-navigation.acqua-navigation');
    if (!candidate) return;
    var parts = {
      nav: candidate.querySelector('.department-nav'),
      sources: candidate.querySelector('.acqua-nav-sources'),
      modal: candidate.querySelector('#nav-modal'),
      backdrop: candidate.querySelector('.acqua-navigation-backdrop'),
      index: candidate.querySelector('.department-index'),
      detail: candidate.querySelector('.department-detail'),
      title: candidate.querySelector('.mobile-department-title')
    };
    if (Object.keys(parts).some(function (key) { return !parts[key]; })) return;
    root = candidate;
    root.classList.toggle('is-design-mode', !!(window.Shopify && window.Shopify.designMode));
    nav = parts.nav;
    sources = parts.sources;
    modal = parts.modal;
    backdrop = parts.backdrop;
    index = parts.index;
    detail = parts.detail;
    title = parts.title;
    mobileToggle = document.querySelector('[data-acqua-menu-toggle]');
    build();
    restoreEditorView();
  }

  function editorEvent(event) {
    if (event.type === 'shopify:section:unload') {
      var unloadedSectionId = event.detail && event.detail.sectionId;
      var unloadingDepartment = departments.some(function (item) {
        return item && (item.mount === event.target || item.mount.contains(event.target) ||
          (unloadedSectionId && item.source.dataset.sectionId === unloadedSectionId));
      });
      if (root && (event.target.contains(root) || root.contains(event.target) || unloadingDepartment)) {
        rememberEditorView();
        destroy();
      }
      return;
    }
    if (event.type === 'shopify:block:select' || event.type === 'shopify:section:select') {
      if (!root || (!root.contains(event.target) && !event.target.contains(root))) return;
      var editorTarget = event.target;
      if (event.detail && event.detail.blockId) {
        var marked = Array.prototype.slice.call(root.querySelectorAll('[data-shopify-editor-block]'))
          .find(function (element) {
            var block = editorBlock(element);
            return block && (block.id === event.detail.blockId || block.domId === event.detail.blockId);
          });
        if (marked) editorTarget = marked;
      }
      var source = editorTarget.closest('[data-nav-source]');
      if (!source) {
        var containingDepartment = departments.find(function (item) {
          return item && (item.mount === editorTarget || item.mount.contains(editorTarget) ||
            item.source.contains(editorTarget) || item.panel.contains(editorTarget));
        });
        source = containingDepartment && containingDepartment.source;
      }
      var department = departments.find(function (item) { return item && item.source === source; });
      if (!department && event.type === 'shopify:section:select') {
        var sectionId = event.detail && event.detail.sectionId;
        if (sectionId) {
          department = departments.find(function (item) {
            return item && item.source.dataset.sectionId === sectionId;
          });
        }
        if (!department) {
          department = departments.find(function (item) {
            if (!item) return false;
            var wrapper = item.source.closest('[id^="shopify-section-"]');
            return wrapper === event.target;
          });
        }
        if (!department) {
          var contained = departments.filter(function (item) {
            return item && event.target.contains(item.source);
          });
          if (contained.length === 1) department = contained[0];
        }
      }
      if (!department) return;
      open(department, false);
      var axisPanel = editorTarget.closest('[data-nav-axis]');
      var axis = department.axes.find(function (item) { return item.panel === axisPanel; });
      if (axis) setAxis(department, axis, false);
      return;
    }
    if (event.type === 'shopify:section:load' && root &&
      document.querySelector('[data-acqua-menu-toggle]') !== mobileToggle) {
      window.requestAnimationFrame(init);
      return;
    }
    if (root && root.isConnected && !root.contains(event.target) && !event.target.contains(root)) return;
    window.requestAnimationFrame(init);
  }

  document.addEventListener('shopify:section:load', editorEvent);
  document.addEventListener('shopify:section:unload', editorEvent);
  document.addEventListener('shopify:section:reorder', editorEvent);
  document.addEventListener('shopify:section:select', editorEvent);
  document.addEventListener('shopify:block:select', editorEvent);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
